import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { Shop } from '../models/shop';
import { FirestoreService } from './firestore-utils/firestore.service';
import {EmailService} from './email.service';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  private currentShop$ = new BehaviorSubject<Shop>(null);
  private currentShopSub = new Subscription();

  constructor(
    private firestoreService: FirestoreService,
    private emailService: EmailService
  ) { }

  setCurrentShop(uid: string) {
    if (this.currentShop$.value && this.currentShop$.value.uid === uid ) { return; }

    this.currentShopSub.unsubscribe();
    this.currentShopSub = this.observeShop(uid).subscribe(shop => this.currentShop$.next(shop));
  }

  getCurrentShop() {
    return this.currentShop$.asObservable();
  }

  getShop(uid: string): Promise<Shop> {
    return this.firestoreService.getRecord('shops', uid) as Promise<Shop>;
  }

  getShopByEmail(email: string): Promise<Shop> {
    return this.firestoreService.getRecordByProperty('shops', 'email', '==', email) as Promise<Shop>;
  }

  getShops(): Promise<Shop[]> {
    return this.firestoreService.getCollection('shops');
  }

  addShop(shop: Shop): Promise<Shop> {
    return this.firestoreService.addOrUpdateRecord('shops', JSON.parse(JSON.stringify(shop))) as Promise<Shop>;
  }

  updateShop(shop: Shop): Promise<Shop> {
    return this.firestoreService.addOrUpdateRecord('shops', JSON.parse(JSON.stringify(shop))) as Promise<Shop>;
  }

  removeShop(uid: string) {
    return this.firestoreService.removeRecord('shops', uid);
  }

  observeShop(uid: string): Observable<Shop> {
    return this.firestoreService.observeRecord('shops', uid);
  }

  observeShops(): Observable<Shop[]> {
    return this.firestoreService.observeCollection('shops');
  }

  sendNewShopEmail(shop) {
    let content = '';

    const fullAddress: string =
        shop.address.address +
        ', ' +
        shop.address.postalCode +
        ' ' +
        shop.address.local;

    const shopInformation =
        '<div>' +
        shop.name +
        '</div>' +
        '<div><b>' +
        fullAddress +
        '</div>' +
        '<div><b>' +
        shop.email +
        '</div>' +
        '<div><b>' +
        shop.fiscalNumber +
        '</div>' +
        '<div><b>' +
        shop.tel +
        '</div>';

    content += shopInformation;

    if (shop.iban) {
      console.log('Has IBAN');
      content +=
          '<div>' +
          shop.iban +
          '</div>';
    }

    return this.emailService.sendEmail('scuverpt@gmail.com', 'Novo Restaurante', content);
  }

  getShopsWithinBounds(latLng, rests) {

    return new Promise((resolve, reject) => {

      const results = [];

      const restaurants = rests
          .filter(r => !!r.uid)
          .filter(r => r.address && r.address.coordinates && r.address.coordinates.latitude && r.address.coordinates.longitude)
          .filter(r => r.deliveryCoverage);

      restaurants.forEach(business => {
        const distanceHaversine =
            this.haversineDistance(business.address.coordinates.latitude, business.address.coordinates.longitude, latLng.lat, latLng.lng);
        console.log('distance', distanceHaversine);
        if (distanceHaversine <= business.deliveryCoverage) {
          results.push(business);
        }
      });

      resolve(results);
    });
  }

  private haversineDistance(lat1, lon1, lat2, lon2) {
    const toRadian = angle => (Math.PI / 180) * angle;
    const distance = (aaa, b) => (Math.PI / 180) * (aaa - b);
    const RADIUS_OF_EARTH_IN_KM = 6371;

    const dLat = distance(lat2, lat1);
    const dLon = distance(lon2, lon1);

    lat1 = toRadian(lat1);
    lat2 = toRadian(lat2);

    // Haversine Formula
    const a =
        Math.pow(Math.sin(dLat / 2), 2) +
        Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.asin(Math.sqrt(a));

    return RADIUS_OF_EARTH_IN_KM * c;
  }
}
